import React from "react";

import {
  FaClone,
  FaExclamationTriangle,
  FaRocket,
  FaTimes,
  FaTrashAlt,
} from "react-icons/fa";

const TONES = {
  green: {
    icon: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300",
    button:
      "bg-emerald-600 text-white hover:bg-emerald-700",
  },

  purple: {
    icon: "bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300",
    button:
      "bg-violet-600 text-white hover:bg-violet-700",
  },

  red: {
    icon: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300",
    button:
      "bg-rose-600 text-white hover:bg-rose-700",
  },
};

function getIcon(type) {
  if (type === "publish") {
    return <FaRocket />;
  }

  if (type === "duplicate") {
    return <FaClone />;
  }

  if (type === "delete") {
    return <FaTrashAlt />;
  }

  return <FaExclamationTriangle />;
}

export default function ConfirmTutorialDialog({
  confirmation,
  loading,
  onClose,
  onConfirm,
}) {
  if (!confirmation) {
    return null;
  }

  const tone =
    TONES[confirmation.tone] || TONES.red;

  return (
    <div className="fixed inset-0 z-[1400] flex items-center justify-center p-4">
      <button
        type="button"
        aria-label="Fermer"
        className="absolute inset-0 bg-slate-950/70 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative w-full max-w-lg overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-[0_35px_100px_-30px_rgba(0,0,0,0.55)] dark:border-slate-800 dark:bg-slate-900">
        <div className="p-6">
          <div
            className={`flex h-14 w-14 items-center justify-center rounded-2xl text-xl ${tone.icon}`}
          >
            {getIcon(confirmation.type)}
          </div>

          <h3 className="mt-5 text-xl font-semibold text-slate-900 dark:text-slate-50">
            {confirmation.title}
          </h3>

          <p className="mt-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
            {confirmation.description}
          </p>

          <div className="mt-4 rounded-2xl bg-slate-100 px-4 py-3 dark:bg-slate-800">
            <div className="font-semibold text-slate-900 dark:text-slate-50">
              {confirmation.tutorial?.titre}
            </div>

            <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Version{" "}
              {confirmation.tutorial?.version}
            </div>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 dark:border-slate-800 dark:bg-slate-950/50 sm:flex-row sm:justify-end">
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200"
          >
            <FaTimes />
            Annuler
          </button>

          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className={`inline-flex items-center justify-center gap-2 rounded-2xl px-4 py-2.5 text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50 ${tone.button}`}
          >
            {getIcon(confirmation.type)}

            {loading
              ? "Traitement..."
              : confirmation.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}